export enum HttpParameterSubRoute {
    Communication = "communication",
    Location = "location",
    Notification = "notification",
    RestaurantAccount = "restaurantAccount",
    RestaurantMenu = "restaurantMenu",
    Restaurant = "restaurant",
    RestaurantOrder = "restaurantOrder",
    RestaurantSetting = "restaurantSetting",
    UserAccount = "userAccount",
    Payments = "payments",
    Subscriptions = "subscriptions",
    Reports = "reports",
    ReportsMicroservice = "reports-microservice",
    Config = "config",
    Transactions = "transactions",
    Business = "business",
    RestaurantOrderVersionTwo = "restaurantOrderVersionTwo",
    Services = "services",
    Assets = "assets",
    kdsSetup = "kdsSetup",

    oldReports = "oldReports",
    kdsSetupActiveDisplay = "kdsSetupActiveDisplay",
    // Migration = "migrate",
}
